'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _template = require('lodash/template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var altTemplate = function altTemplate(str, progress) {
  var compileTemplate = (0, _template2.default)(str);
  return compileTemplate({ progress: progress });
};

var ProgressBar = function ProgressBar(_ref) {
  var classNames = _ref.classNames,
      alt = _ref.alt,
      _ref$progress = _ref.progress,
      progress = _ref$progress === undefined ? 0 : _ref$progress;
  return _react2.default.createElement(
    'div',
    { className: 'c11n-progress-bar ' + classNames.root },
    _react2.default.createElement('div', { className: classNames.fill, 'aria-hidden': true }),
    _react2.default.createElement(
      'div',
      { className: classNames.alt },
      altTemplate(alt, progress)
    )
  );
};

ProgressBar.propTypes = {
  /**
   * The alt text for the progress bar. Takes a `progress` value in a valid [Lodash Template](https://lodash.com/docs/4.17.4#template). E.g. `'<%= progress %>% there'`
   */
  alt: _propTypes2.default.string.isRequired,

  /**
   * The progress amount (percentage)
   */
  progress: _propTypes2.default.number.isRequired,

  /**
   * The fill color of the progress bar -
   */
  fill: _propTypes2.default.string,

  /**
   * The background color of the progress bar -
   */
  background: _propTypes2.default.string,

  /**
   * The border radius of the progress bar -
   */
  radius: _propTypes2.default.string,

  /**
   * Custom styles to be applied to the progress bar
   */
  styles: _propTypes2.default.object
};

ProgressBar.defaultProps = {
  fill: 'primary',
  background: 'shade',
  radius: 'small',
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(ProgressBar);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/progress-bar/index.js
// module id = 240
// module chunks = 0